import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import VueSweetalert2 from "vue-sweetalert2";
// import VueQrcodeReader from "vue-qrcode-reader";
import moment from "moment";
import cognitoAuth from "./cognito";
import router from "./router";
import store from "./store";
import Vuetify from "vuetify";
import "sweetalert2/dist/sweetalert2.min.css";
localStorage.setItem("currentUser", JSON.stringify({}));
localStorage.setItem("currentUserData", JSON.stringify({}));

Vue.use(Vuetify);

Vue.directive("clickable", {
  inserted: function (el) {
    el.style.cursor = "pointer";
  },
});

Vue.prototype.$moment = moment;

Vue.config.productionTip = false;

Vue.use(VueSweetalert2);

Vue.use(moment);

new Vue({
  vuetify,
  router,
  cognitoAuth,
  store,
  head: {
    meta: [
      {
        name: "viewport",
        content:
          "width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover",
      },
    ],
  },
  beforeCreate() {
    // this.$store.dispatch("initAuth");
    // setInterval(() => {
    //   this.$store.dispatch("initAuth");
    //   console.log("Initializing Auth");
    // }, 300000);
    // this.$store.dispatch("setFullLoaderState", true);
    // this.$store.dispatch("loadSiteData").then(() => {
    //     this.$store.dispatch("initAuth");
    // });
  },
  render: (h) => h(App),
}).$mount("#app");
